<template>
  <base-view title="Estado del Ejercicio del Presupuesto de Egresos por Fuente de Financiamiento-Proyecto-Unidad Administrativa-Partida">
    <div class="container-fluid mt-4">
      <div class="card">
        <div class="card-body">
          <reporte-estado-ppto-egresos/>
        </div>
      </div>
    </div>
  </base-view>
</template>

<script>
import ReporteEstadoPptoEgresos from '@/components/Reportes/ReporteEstadoPptoEgresos/ReporteEstadoPptoEgresos'

export default {
  name: 'ReporteEstadoPptoEgresosView',

  components: {
    ReporteEstadoPptoEgresos
  }
}
</script>
